// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ModuleList } from "../../../components/module_list/ModuleList";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModuleList,
  },
})
export class RechtlicheKlausel extends ModuleBase {
  private isAccepted: boolean = false;

  private showError: boolean = false;

  private checkboxState: boolean = false;

  private expirationDays: number = 1;

  public mounted() {
    this.isAccepted = this.hasAlreadyAccepted();
  }

  get cookieName() {
    return "katalog_rechtliche_klausel_" + this.id;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  get unacceptedModules() {
    return this.instance["__children"][0]["content"]["__children"];
  }

  get acceptedModules() {
    return this.instance["__children"][1]["content"]["__children"];
  }

  private handleClick(event) {
    if (this.checkboxState) {
      this.showError = false;
      this.isAccepted = true;
      this.setCookie();
    } else {
      this.showError = true;
    }
  }

  private setCookie() {
    let d = new Date();
    d.setTime(d.getTime() + this.expirationDays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie =
      this.cookieName + "=1" + ";" + expires + ";path=/; SameSite=None; Secure";
  }

  private hasAlreadyAccepted() {
    let cookieValue = this.getCookie();

    return cookieValue == "1";
  }

  private getCookie() {
    let name = this.cookieName + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}
